/* eslint-disable react/prop-types */
import React, { useState } from "react";
import { useAsyncDebounce } from "react-table";
import Icon from "../../Icon";
const SearchTable = ({
  globalFilter,
  setGlobalFilter,
  placeholder = "Buscar...",
  size = "sm",
}) => {
  const [value, setValue] = useState(globalFilter);
  const onChange = useAsyncDebounce((value) => {
    setGlobalFilter(value || undefined);
  }, 200);

  return (
    <div className="relative w-full !my-2">
      <Icon
        icon="search"
        className={
          "absolute left-4 top-1/2 transform -translate-y-1/2 w-5 h-5 text-slate-400"
        }
      />
      <input
        type="text"
        value={value || ""}
        onChange={({ target: { value } }) => {
          setValue(value);
          onChange(value);
        }}
        placeholder={placeholder}
        size={size}
        className="w-full pl-12 py-1.5 bg-white  border border-slate-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500  text-slate-900 placeholder-slate-400  transition-all"
      />
    </div>
  );
};

export default SearchTable;
